module.exports = __webpack_public_path__ + "static/media/gridItem5.763caf68.jpg";